import * as DropdownMenu from "@radix-ui/react-dropdown-menu"
import { ChevronDownIcon } from "@radix-ui/react-icons"
import { Routes } from "@blitzjs/next"
import Link from "next/link"
import { useRouter } from "next/router"
import { CITIES } from "../app/features/regional-map/regional-map.constants"

// sort cities alphabetically
CITIES.sort((a, b) => a.title.localeCompare(b.title))

export default function ChooseAnalyzer(props: { text: string; className?: string }) {
  const router = useRouter()
  const { text, className } = props
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button className={`${className}`}>
          <span className="inline">{text} </span>
          <ChevronDownIcon className="-mt-1 inline" />
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content sideOffset={5}>
        <div className="mr-4 bg-white py-2 shadow">
          {router.pathname !== Routes.TesaHome().pathname && (
            <DropdownMenu.Item key="analyzers">
              <Link href={Routes.TesaHome()}>
                <p className="py-1.5 pl-4 font-extrabold text-brand-green-dark decoration-[#f9c793] decoration-4 underline-offset-8 hover:underline">
                  Explore analyzers
                </p>
              </Link>
            </DropdownMenu.Item>
          )}
          {CITIES.filter((city) => city.id != "national").map((city, i) => {
            return (
              <DropdownMenu.Item key={city.id}>
                <Link key={i} href={Routes.LandingPage({ city: city.id })}>
                  <p className="py-1.5 pl-4 pr-6 font-medium text-brand-green-dark decoration-[#f9c793] decoration-4 underline-offset-8 hover:underline">
                    {city.title}
                  </p>
                </Link>
              </DropdownMenu.Item>
            )
          })}
        </div>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  )
}
